import iconHelper from '@bazooka_se/lf-icons';

const camelcaseKeys = require('camelcase-keys-deep');

let documentList;
let loader;
let holder;

function fetchDocuments() {

    holder = document.querySelector('.my-documents--content');
    loader = holder.querySelector('.loader');

    const settings = {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin', // attach cookies for local domain
    };
    const baseURL = '/dokument/';

    fetch(new Request("/lf-data-authenticated/api/v1/documents", settings))
        .then((response) => {
            if (!response.ok) {
                throw new Error(`Network response was not ok, status: ${response.status}`);
            }

            return response.json();
        }).then((data) => {
            loader.classList.remove('loader--active');
            data = camelcaseKeys(data, {deep: true});

            if (data.result.documents.length == 0) {
                return holder.classList.remove('has-documents');
            }

            data.result.documents.forEach(row => {
                const documentUrl = baseURL + row.documentId + '/' + row.documentName;

                const li = document.createElement('li');

                const span = document.createElement('span');
                const a = document.createElement('a');
                const aDownload = document.createElement('a');

                span.classList.add('date');
                span.innerText = row.createdDate;

                a.target = '_blank';
                a.className = 'link pdf';
                a.href = documentUrl;
                a.appendChild(iconHelper('document'))
                a.innerHTML += row.documentName;

                aDownload.className = 'download';
                aDownload.setAttribute('download', '');
                aDownload.href = documentUrl + '?download=true';
                aDownload.appendChild(iconHelper('download'));

                [span, a, aDownload].forEach(c => li.appendChild(c));
                documentList.appendChild(li);
            });

            if(window._bazDebug)  {
                console.warn('[DEBUG] Response data: ');
                console.dir(data);
            }
        })
        .catch ((error) => {
        // Handle errors here
        console.error('Error during fetch:', error);

        // TODO: Display the error to the user or take appropriate action
    });
}

export default function documentListLoader() {
    documentList = document.querySelector('.my-documents-list');

    if (documentList) {
        fetchDocuments();
    }
}